import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function Allcategory() {
  const [category, setCategory] = useState([]);
  const [seeCategory, setSeeCategory] = useState({});
  const [seCategory, setSeCategory] = useState("");
  const [editId, setEditId] = useState("");

  const Getcategory = async () => {
    const res = await fetch(
      "https://capobiz-backend.vercel.app/api/auth/getcategory",
      { method: "GET" }
    );
    const data = await res.json();
    setCategory(data);
  };

  useEffect(() => {
    Getcategory();
  }, []);

  const viewCategory = async (id) => {
    const res = await fetch(
      `https://capobiz-backend.vercel.app/api/auth/getcategory/${id}`,
      { method: "GET" }
    );
    const data = await res.json();
    setSeeCategory(data);
  };

  const deleteCategory = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This category will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await fetch(
        `https://capobiz-backend.vercel.app/api/auth/delcategory/${id}`,
        { method: "DELETE" }
      );

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Category has been deleted",
        timer: 2000,
        showConfirmButton: false,
      });

      Getcategory();
    }
  };

  const editCategory = async (id) => {
    const res = await fetch(
      `https://capobiz-backend.vercel.app/api/auth/getcategory/${id}`,
      { method: "GET" }
    );
    const data = await res.json();
    setSeCategory(data.category);
    setEditId(data._id);
  };

  const updateCategory = async () => {
    await fetch(
      `https://capobiz-backend.vercel.app/api/auth/editcategory/${editId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ category: seCategory }),
      }
    );

    Swal.fire({
      icon: "success",
      title: "Updated!",
      text: "Category has been updated",
      timer: 2000,
      showConfirmButton: false,
    });

    Getcategory();
  };

  return (
    <div>
      <h2 className="pt-5 text-center pb-2">Categories List</h2>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Category</th>
            <th style={{ width: "300px" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {category &&
            category
              .slice()
              .reverse()
              .map((post) => (
                <tr key={post._id}>
                  <td>{post.category}</td>
                  <td className="d-flex gap-2">
                  
                    <button
                      className="btn btn-primary btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#viewModal"
                      onClick={() => viewCategory(post._id)}
                    >
                      View 
                    </button>

                    <button
                      className="btn btn-primary btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#editModal"
                      onClick={() => editCategory(post._id)}
                    >
                      Edit
                    </button>

                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => deleteCategory(post._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
        </tbody>
      </table>

      {/* View Modal */}
      <div className="modal fade" id="viewModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <label className="form-label">Category</label>
              <input
                className="form-control"
                value={seeCategory.category || ""}
                disabled
              />
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <div className="modal fade" id="editModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <label className="form-label">Category</label>
              <input
                className="form-control"
                value={seCategory}
                onChange={(e) => setSeCategory(e.target.value)}
              />
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={updateCategory}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
